import { useAppSelector } from '@src/core/hooks';
import { featureFlagsSelector } from '@src/features/auth';

type FeatureFlagHook = {
  isFeatureFlagEnabled: (feature: keyof typeof FeatureFlags) => boolean;
};

export const FeatureFlags = {
  'PR-1858-new-phone-input': true,
  'PR-2195-collect-buyer-birthdate': true,
  'PR-2195-collect-buyer-cep': true,
  'PR-646-product-packages': true,
};

export const useFeatureFlag = (): FeatureFlagHook => {
  const featureFlags = useAppSelector(featureFlagsSelector());

  const isFeatureFlagEnabled = (feature: keyof typeof FeatureFlags): boolean => {
    if (!featureFlags) {
      console.warn('Feature flags not found. Check if it is correctly configured.');
      return false;
    }

    if (!(feature in featureFlags) || featureFlags[feature] === undefined) {
      console.warn(`Feature flag ${feature} not found. Check if it is correctly configured.`);
      return false;
    }

    return featureFlags[feature];
  };

  return {
    isFeatureFlagEnabled,
  };
};

export default useFeatureFlag;
